import axios from 'axios';
import { baseUrl } from '../settings';
import authHeader from './auth-header';

const API_URL = baseUrl;

class ToolService {
  doRemoveBackground(uploadedFiles) {
    var formData = new FormData();
    formData.append("source_image_file", uploadedFiles[0]);

    var header = {'Content-Type': 'multipart/form-data', 
      'Authorization' :'Bearer 8c9970f5-68e5-47b4-8aec-1e70e0c76659'};
    
    return axios.post(API_URL + '/remove_background', formData, { headers: 
      header });
  }

  useCredits(data) {
    var formData = new FormData();
    formData.append("original_image_id", data);

    return axios.post(API_URL + '/UseCredits', formData, { headers: 
      authHeader() });
  }
}

export default new ToolService();